import axios from "@/lib/axios";
import { GetResponsesByQuizIdItem } from "./responses-by-quiz-id.request";

export type GetResponseByIdRequestParams = {
  companyId: string;
  quizId: string;
  responseId: string;
};

export type GetResponseByIdResponse = GetResponsesByQuizIdItem;

export const getResponseById = (
  params: GetResponseByIdRequestParams,
  signal?: AbortSignal,
) =>
  axios
    .get<GetResponseByIdResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses/${params.responseId}`,
      {
        signal,
      },
    )
    .then((res) => res.data);
